import { render } from "./PagesNav.vue?vue&type=template&id=318c0340"
import script from "./PagesNav.vue?vue&type=script&lang=js"
export * from "./PagesNav.vue?vue&type=script&lang=js"

import "./PagesNav.vue?vue&type=style&index=0&id=318c0340&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__